export default __webpack_public_path__ + "static/media/IconPinterest.20b3e48b.svg";